export default "__VITE_ASSET__BsIPrKKN__"